var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ActivityPanel,{attrs:{"title":"Settings","go-to-all-title":"User Preferences","href":"/user"}},[_c('h3',[_vm._v("Customize Activity Bar")]),_vm._v(" "),_c(_setup.ActivitySettings)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }